import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';

type NftVideoMediaProps = {
  src?: string;
  controls: boolean;
  loop: boolean;
  poster?: string;
  hover: boolean;
  autoplay: boolean;
  isBestNft?: boolean;
  onLoad?: () => void;
  onPlay: () => void;
  onPause: () => void;
};

export const NftVideoMedia: FC<NftVideoMediaProps> = ({
  src,
  controls,
  poster,
  autoplay,
  isBestNft,
  onLoad,
  onPause,
  onPlay
}) => {
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handlePlay = () => {
      onPlay();
    };

    const handlePause = () => {
      onPause();
    };

    if (videoElement) {
      videoElement.addEventListener('play', handlePlay);
      videoElement.addEventListener('pause', handlePause);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('play', handlePlay);
        videoElement.removeEventListener('pause', handlePause);
      }
    };
  }, [onPlay, onPause]);

  return (
    <Styled.Video
      width="100%"
      height="100%"
      loop
      controls={controls}
      poster={poster}
      $round
      autoPlay={autoplay}
      $isBestNft={isBestNft}
      onLoad={onLoad}
      ref={videoRef}
    >
      <source src={src} />
      {t('generic.browserNotSupportVideo')}
    </Styled.Video>
  );
};
